import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import * as FileSaver from "file-saver";
import { ToastrService } from "ngx-toastr";
import { DataDirectoryService } from "../data-directory/data-directory.service";
import { DomSanitizer } from "@angular/platform-browser";
import { environment } from "src/environments/environment.prod";
import * as XLSX from "xlsx";
import { LifecycleintellegenceService } from "./lifecycleintellegence.service";

@Component({
  selector: "app-lifecycleintellegence",
  templateUrl: "./lifecycleintellegence.component.html",
  styleUrls: ["./lifecycleintellegence.component.scss"],
})
export class LifecycleintellegenceComponent implements OnInit {
  @ViewChild("headerids", { static: false }) headerids: ElementRef;
  links = 'window.open("http://43.205.223.1:8000';
  DragData: any = {};
  typeArray = ["paraI", "paraII", "paraIII", "paraIV"];
  newArray = [];
  contentTableArray = [];
  popupcontents: any;
  contentPopups = "none";
  content_Details: [];
  content_value: "";
  sliceEnd = 5;
  contentKey = "";
  displaypopup = "none";
  data: [][];
  refEditData = {};
  submolecules: any[];
  subMolecule = false;
  selectedSubMolecule: any;
  Molecule = false;
  searchValue = "";
  noData = false;
  showedit = false;
  tempData: any = {};
  changed_Cols: [];
  nullmessage: any = "";
  tablekeys: string[];
  tableData: any = [];
  tablevalues: any = [];
  colorcode: {};
  // #headerid/
  setWidth: any;
  objectKeys = Object.keys;
  objectValues = Object.values;
  linkURL: any;
  paramsValues: any;
  editedData: any;
  storedData: any;
  keysArray: Array<String> = [];
  keyIds: Array<String> = [];
  showCheckBox = false;
  options: any = [];
  secondSectionData: any = {};
  thirdSectionData: any = {};
  fourthSectionData: any = {};
  ApiInformationData: any = {};
  FormulationData: any = {};
  CompetitiveData: any = {};
  ExecutiveData: any = {};
  activeIngredientforPI: any;
  ndaforPI: any;
  brandNameforPI: any;
  CostingData: any = {};
  nda_number: any;

  // user specific page allowance.
  page_access = { total_count: "undefined" };
  total_count = "undefined";

  constructor(
    private ref: ChangeDetectorRef,
    public toastr: ToastrService,
    private route: ActivatedRoute,
    private directoryservice: DataDirectoryService,
    private lifecycleintellegenceservice: LifecycleintellegenceService,
    private sanitized: DomSanitizer
  ) {
    this.submolecules = [];
    if (
      this.directoryservice.serchKey &&
      this.directoryservice.serchKey != ""
    ) {
      this.searchValue = this.directoryservice.serchKey;
    }
  }
  ngOnInit() {
    this.paramsValues = this.route.snapshot.queryParams;
    if (
      this.paramsValues.active_ingredient &&
      this.paramsValues.brand_name &&
      this.paramsValues.ndaValue &&
      this.paramsValues.section
    ) {
      this.getEditedChanges(
        this.paramsValues.active_ingredient,
        this.paramsValues.brand_name,
        this.paramsValues.ndaValue
      );
      this.Molecule = true;
    }
    this.page_access = JSON.parse(localStorage.getItem("page_access")) || {
      total_count: "undefined",
    };
    this.total_count = this.page_access.total_count || "undefined";
  }

  clearFilter() {
    this.submolecules = [];
    this.selectedSubMolecule = {};
    this.Molecule = false;
    this.searchValue = "";
    this.subMolecule = false;
    this.noData = false;
  }
  showArray(data, n2, n3, n4, n5, n6, n7) {
    this.contentPopups = "block";
    this.contentTableArray = data;
  }
  Selectparam(event) {
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = JSON.parse(referdata);
    let brand_name: any;
    brand_name = moleculedata["Brand Name/Proprietary Name"];
    let obj = {
      type: event.target.value,
      brand_name: moleculedata["Brand Name/Proprietary Name"],
    };
    this.lifecycleintellegenceservice.addPara(obj).subscribe((res) => { });
  }

  showLess(data, n2, n3, n4, n5, n6, n7) {
    this.contentPopups = "block";
    this.tablekeys = Object.keys(data[0]);
    this.tablevalues = data;
  }

  // arrayToDropdown(InputArray) {
  //   const DropDownArray = [{ name: InputArray }];
  //   return DropDownArray;
  // }

  arrayToDropdown(InputArray) {
    let DropDownArray = [];
    InputArray.forEach((DropdownValues) => {
      let dropDownObj = {};
      dropDownObj["name"] = DropdownValues;
      dropDownObj["code"] = DropdownValues;
      DropDownArray.push(dropDownObj);
    });
    return DropDownArray;
  }

  /**
   *
   * @param InputProperty  value entered
   * @param Objectvalue     object values of the keys in an object
   * @returns
   */
  getcolorcode(InputProperty: string, Objectvalue: any): any {
    if (Objectvalue[InputProperty] !== undefined) {
      return Objectvalue[InputProperty];
    } else {
      return "";
    }
  }
  /**
   * Method to handle search
   */

  searchMolecule() {
    this.submolecules = [];
    this.lifecycleintellegenceservice
      .getNdaData(this.searchValue)
      .subscribe((ndaValues) => {
        if (ndaValues["data"].nda_numbers.length > 0) {
          const number = ndaValues["data"].nda_numbers;
          // const elements = number.split(",");
          // const secondElement1 = elements[1];
          // console.log(secondElement1); // Output: 123456
          debugger;
          let dropdownvalues = this.arrayToDropdown(number);
          this.submolecules = dropdownvalues;
          const Array = this.submolecules[0].name.split(",")[1];
          this.nda_number = Array;
          this.subMolecule = true;
          this.Molecule = false;
          this.DragData = {};
        } else {
          this.selectedSubMolecule = {};
          this.subMolecule = false;
          this.Molecule = false;
          this.DragData = {};
        }
      });
  }

  getEditedValues() {
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = JSON.parse(referdata);
    let active_ingredient = moleculedata["Active Ingredient"];
    let brand_name = moleculedata["Brand Name/Proprietary Name"];
    let ndaNumber = moleculedata["NDA number"];
    this.getEditedChanges(active_ingredient, brand_name, ndaNumber);
  }

  getEditedChanges(
    active_ingredient: string,
    brand_name: string,
    ndaNumber: number
  ) {
    this.lifecycleintellegenceservice
      .sectionOneEditedData(active_ingredient, brand_name, ndaNumber)
      .subscribe((res: any) => {
        if (this.paramsValues.section === "innovator_details") {
          this.DragData = res.previously_updated_db_data;
          this.storedData = res.data.edited_data_key_insert_to_db;
        }
      });
  }

  isChanged(key): any {
    this.keysArray = [];
    if (this.storedData) {
      Object.keys(this.storedData).map((keys) => {
        if (keys === key) {
          this.keysArray.push(keys);
        }
      });
      return this.keysArray;
    }
  }

  getData() {
    if (this.selectedSubMolecule !== undefined) {
      let ndaValue = this.selectedSubMolecule["name"].split(",")[1];
      this.lifecycleintellegenceservice
        .getDrugData(ndaValue)
        .subscribe((MoleculeData: any) => {
          if (MoleculeData !== null) {
            localStorage.setItem("molecules", JSON.stringify(MoleculeData));
            let referdata: any = localStorage.getItem("molecules");
            let moleculedata: any = JSON.parse(referdata);
            let active_ingredient: any;
            if (Array.isArray(MoleculeData["Active Ingredient"]) === false) {
              active_ingredient = moleculedata["Active Ingredient"].replace(
                /\s/g,
                "%20"
              );
            } else {
              active_ingredient = moleculedata["Active Ingredient"]
                .join("&")
                .replace(/\s/g, "%20");
            }
            let brand_name = moleculedata[
              "Brand Name/Proprietary Name"
            ].replace(/\s/g, "%20");
            let ndaValue = moleculedata["NDA number"];
            let sectionOne = "innovator_details";
            this.linkURL = `${environment.ip}/#/lifecycleintelligence?active_ingredient=${active_ingredient}&brand_name=${brand_name}&ndaValue=${ndaValue}&section=${sectionOne}`;
            // this.linkURL = `http://3.111.249.237/#/lifecycleintelligence?active_ingredient=${active_ingredient}&brand_name=${brand_name}&ndaValue=${ndaValue}&section=${sectionOne}`;
            this.noData = false;
            this.ref.detectChanges();
            this.brandNameforPI = brand_name;
            this.ndaforPI = ndaValue;
            this.activeIngredientforPI = active_ingredient;
            // Calling First Section API
            this.lifecycleintellegenceservice
              .getFirstSection(ndaValue)
              .subscribe((InnovatorDetails: any) => {
                this.Molecule = true;
                //extract colour coding
                this.colorcode =
                  InnovatorDetails.data["INNOVATOR/BRAND PRODUCT DETAILS"][
                  "colorindicator"
                  ];
                this.DragData =
                  InnovatorDetails.data["INNOVATOR/BRAND PRODUCT DETAILS"];
                this.tempData =
                  InnovatorDetails.data["INNOVATOR/BRAND PRODUCT DETAILS"];
                this.refEditData =
                  InnovatorDetails.data["INNOVATOR/BRAND PRODUCT DETAILS"];
              });
          } else {
            this.noData = true;
            this.Molecule = false;
            this.DragData = {};
            this.tempData = {};
            this.refEditData = {};
          }
        });
    }
  }

  HandleInput(evt) {
    const target: DataTransfer = <DataTransfer>evt.target;
    if (target.files.length !== 1) throw new Error("Cannot use multiple files");
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: "binary" });
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      this.data = XLSX.utils.sheet_to_json(ws, { header: 1 });
      let x = this.data.slice(1);
    };
    reader.readAsBinaryString(target.files[0]);
  }

  editbtn() {
    this.showedit = !this.showedit;
    if (this.showedit === true) {
      this.sliceEnd = 1000;
    } else {
      this.sliceEnd = 5;
    }
  }

  downloadFiles() {
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = JSON.parse(referdata);
    this.lifecycleintellegenceservice
      .getdownloadfile({
        nda_number: moleculedata["NDA number"],
        brand_name: moleculedata["Brand Name/Proprietary Name"],
      })
      .subscribe((res) => {
        let resp = res["data"]["content"];
        let file = res["data"]["filename"];
        FileSaver.saveAs(
          `data:application/vnd.ms-excel;base64,${resp}`,
          `${file}`
        );
      });
  }

  // Hide and show checboxes
  downloadSelected() {
    this.showCheckBox = !this.showCheckBox;
  }
  // Selecting the checkbox
  selected_checbox(event: any, index: number) {
    if (!this.options.includes(event)) {
      this.options = [...this.options, event];
    } else {
      this.options = this.options.filter((item) => item !== event);
    }
  }
  // Download based on selected items
  downloadSelectedData() {
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = JSON.parse(referdata);
    let columns_data = this.options;
    this.lifecycleintellegenceservice
      .downloadSelected({
        nda_number: moleculedata["NDA number"],
        brand_name: moleculedata["Brand Name/Proprietary Name"],
        columns_data,
      })
      .subscribe((res) => {
        let resp = res["data"]["content"];
        let file = res["data"]["filename"];
        FileSaver.saveAs(
          `data:application/vnd.ms-excel;base64,${resp}`,
          `${file}`
        );
      });
  }

  closecontentpopup() {
    // if (event === 'cancel') {

    this.content_Details = [];
    this.tableData = [];
    this.tablekeys = [];
    this.content_value = "";
    this.contentKey = "";
    this.contentPopups = "none";
    this.contentTableArray = [];
    // }
  }
  addClickEvent(event, value, key) {
    if (
      key === "Dosage and Administration" ||
      key === "Recommended dose" ||
      key === "Indications and Usage"
    ) {
      this.contentPopups = "block";
      this.content_Details = value;
      this.contentKey = key;
      this.content_value = "";
    } else if (
      key === "Variability (% ISCV)" ||
      key === "PK Linearity" ||
      key === "Food effect" ||
      key === "Pharmacology"
    ) {
      this.contentPopups = "block";
      this.content_Details = [];
      this.contentKey = key;
      this.content_value = value;
    } else {
      this.contentPopups = "none";
      this.content_Details = [];
      this.contentKey = "";
      this.content_value = "";
    }
    // if(event.type === 'mouseleave'){
    //   this.contentPopups = 'none';
    //   this.content_Details = [];
    //   this.contentKey ='';
    //   this.content_value ='';
    // }
  }

  addItems(data, n2, n3, n4, n5, n6, n7) {
    let objdata: any = this.DragData;
    let obj = {};
    let arr = [];
    let keys = Object.keys(data[0]);
    for (let i = 0; i <= keys.length - 1; i++) {
      obj[keys[i]] = "";
    }
    objdata[n7].push(obj);
    this.DragData = { ...objdata };
    this.ref.markForCheck();
  }

  addListItem(data, n4, n5, n6, n7) {
    let objdata: any = this.DragData;
    let arr = [];
    console.log("Arrayyyy", objdata[n7].push(arr));
    this.DragData = { ...objdata };
  }

  //** We can edit the data based on object,array and array of objects */
  editdata(event, arr, keys, trows, rd, Obj, index, varikey, n9, n10) {
    if (Obj !== undefined) {
      if (this.tempData[keys] && Obj.value) {
        this.tempData[keys].map((res, j) => {
          Obj.value.map((resp, j1) => {
            if (j === index && j === j1) {
              let objkey = Object.keys(Obj.value[0]);
              let uniquekey = objkey[n10];
              resp[uniquekey] = event.target.value;
            }
          });
        });
      }
    }
    if (Obj === "lItems") {
      if (Array.isArray(this.tempData[keys])) {
        this.tempData[keys].map((respp, k) => {
          if (arr) {
            arr.map((resps, p) => {
              if (p === rd) {
                if (resps === trows) {
                  arr[rd] = event.target.value;
                }
              }
            });
          } else {
          }
        });
      }
    } else if (Obj === undefined) {
      this.tempData[keys] = event.target.value;
    }
  }

  saveEdit() {
    this.sliceEnd = 5;
    this.showedit = !this.showedit;
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = JSON.parse(referdata);
    let editedData: any = {};
    editedData["edited_data"] = this.tempData;
    editedData["nda_number"] = moleculedata["NDA number"];
    editedData["brand_name_proprietary_name"] =
      moleculedata["Brand Name/Proprietary Name"];
    editedData["active_ingredient"] = moleculedata["Active Ingredient"];
    editedData["link"] = this.linkURL;
    this.lifecycleintellegenceservice
      .sendSectionOneEmail(
        editedData["active_ingredient"],
        editedData["brand_name_proprietary_name"],
        editedData["nda_number"],
        editedData
      )
      .subscribe((res: any) => { });
  }

  // Section One UPDATE OR REJECT
  handelAction(key, flag, i) {
    let updatedValue = {
      nda_number: this.paramsValues.ndaValue,
      field: key,
      flag,
      brand_name: this.paramsValues.brand_name,
      active_ingredient: this.paramsValues.active_ingredient,
    };
    this.lifecycleintellegenceservice
      .updateSectionOneMoleculeData(updatedValue)
      .subscribe((res: any) => {
        if (flag === "accept") {
          this.keyIds.push(key.key);
          document.getElementById(key.key).style.display = "none";
          this.toastr.success("Data updated sucessfully", "");
        } else {
          this.DragData = res.old_data_with_updated_set;
          this.keyIds.push(key.key);
          setTimeout(() => {
            this.keyIds.forEach((id: String) => {
              document.getElementById(`${id}`).style.display = "none";
            });
          }, 0);
          this.toastr.error("Data rejected sucessfully", "");
        }
      });
  }

  openPdf(value) {
    // let url: any = window.open(`http://3.111.95.5/pm_backend/${value}`);
    let url: any = window.open(`${environment.ip}pm_backend/${value}`);
    return this.sanitized.bypassSecurityTrustHtml(url);
  }
}
